import UpdateForm from './UpdateForm';

export default UpdateForm;
